import { render, staticRenderFns } from "./FollowingProductionOrderView.vue?vue&type=template&id=408cbd15&"
import script from "./FollowingProductionOrderView.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionOrderView.vue?vue&type=script&lang=js&"
import style0 from "./FollowingProductionOrderView.vue?vue&type=style&index=0&id=408cbd15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports